/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from "react";
import { useHistory, useParams } from 'react-router-dom';
import {
  GET_ALL_DATAREPORTS,
  GET_DATAREPORTS,
  GET_CUSTOMDATAREPORT,
  GET_CUSTOM_REPORT_PREVIEW
} from "../../Querys/reports/querys";
import { useQuery, useLazyQuery, useMutation } from "@apollo/client";
import ReportIndividual from "./ReportIndividual";
import { Grid } from "@material-ui/core";
import Box from '@mui/material/Box';
import CachedIcon from '@mui/icons-material/Cached';
import GridOnIcon from '@mui/icons-material/GridOn';
import SendIcon from '@mui/icons-material/Send';
import DownExcel from "../../assets/icons/downExcel.svg";
import TuneIcon from '@mui/icons-material/Tune';
import { DownloadExcel } from "../../helpers/DownloadExcel";
import { CREATE_CUSTOM_REPORT, GET_ALL_CUSTOMREPORTS } from "../../Querys/querys";
import ReportContext, { Types } from "../../context/ReportsContext/ReportContext";
import AddTable from "../../screens/Colaboradores/Colaboradores/CollaboratorTab/AddTable";
import { SuccessfulAlert } from "../../alerts/successAlerts";
import { renamePivots, renamePropertiesSpanish } from "../../helpers/renamePropertiesSpanish";
import { AttentionAlert2 } from "../../alerts/attentionAlert2";

const ReportInfo = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { state, dispatch } = useContext(ReportContext);
  const [infoReport, setInfoReport] = useState<Array<any>>([]);
  const [report, setReport] = useState<Array<any>>([]);  
  const [reportFilter, setReportFilter] = useState<Array<any>>([]);
  const [viewFilter, setViewFilter] = useState(true)
  const [selViewFilter, setSelViewFilter] = useState('#093C5D')
  const [viewSquare, setViewSquare] = useState(false)
  const [selViewSquare, setSelViewSquare] = useState('#707070')  
  const [camposBd, setCamposBd] = useState<Array<any>>([]);  
  const [camposBdArray, setCamposBdArray] = useState<Array<any>>([]); 
  const [inpuntBdValues, setInpuntBdValues] = useState({}); 
  const [deleteColumns, setDeleteColumns] = useState([]);
  const [inpuntValues,setInpuntValues] = useState([]);
  const [reload, setReload] = useState(false);
  const [columnas, setColumnas] = useState<Array<any>>([]);
  const [nameColumns     ,setNameColumnas]  =  useState<any[]>([])   
  const [filas, setFilas]= useState<Array<any>>([]);
  const [camposPivotes, setCamposPivotes] = useState<Array<any>>([]);
  const [previewLoading, setPreviewLoading] = useState(true)
  const [getReportSingle] = useLazyQuery(GET_DATAREPORTS);
  const [getCustomReportPreview] = useLazyQuery(GET_CUSTOM_REPORT_PREVIEW);
  const [getCustomReportSingle]= useLazyQuery(GET_CUSTOMDATAREPORT);
  
  const { data: reportsInfo } = useQuery(GET_ALL_DATAREPORTS,
    {
      fetchPolicy: 'no-cache',
      skip: id.includes('custom-') || id.includes('preview')
    }
  );

  const { data: customReportsInfo } = useQuery(GET_ALL_CUSTOMREPORTS,
    {
      fetchPolicy: 'no-cache',
      skip: !id.includes('custom-') || id.includes('preview')
    }
  );

  const { data: reportIndividual, loading } = useQuery(GET_DATAREPORTS, {
    variables: { getDatareportsId: id },
    skip: id.includes('custom-') || id.includes('preview'),
    fetchPolicy: 'no-cache'
  });

  const { data: customReportIndividual, loading: loadingCustomReport } = useQuery(GET_CUSTOMDATAREPORT, {
    variables: { getDatareportsId: id?.replace('custom-', '') },
    skip: !id.includes('custom-') || id.includes('preview'),
    fetchPolicy: 'no-cache'
  });

  const [createCustomReport] = useMutation<{
    variables: {
      input: {
        name: string;
        rows?: any[];
        columns?: any[];
        filterJson?: any[];
      }
    }
  }>(CREATE_CUSTOM_REPORT);

  const filterMyReports = (arrayReports: any) => {
    let reports = arrayReports.filter((report: any) => {
      return report.id === id
    }
    )
    return reports
  }

 const goBack = () => {
    dispatch({
      type: 'PREVIEW_DATA',
      payload: null
    })
    history.push('/informes')
  }

const handleViewFilter = () => {
  const newViewFilter = !state.reportPreviewData.viewFilter; 
  const newSelViewFilter = newViewFilter ? "#093C5D" : "#707070";  
  dispatch({
    type: Types.LOAD_DATA_REPORT,
    payload: {
      ...state.reportPreviewData,
      viewFilter: newViewFilter,
      selViewFilter: newSelViewFilter,
    },
  });
};

const handleDownExcel = () => {
    if (state.reportPreviewData?.report.length > 0) {
      const columns = state.reportPreviewData?.report.map((re: any) => {
        return (Object.keys(re))
      });

      const valuesRep = state.reportPreviewData?.report.map((data: any) => {
        return Object.values(data)
      });

      let nameFile  = state.reportPreviewData?.reportName === '' ?state.reportPreviewData?.infoReport[0]?.ReportName :state.reportPreviewData?.reportName
      let sheetName = state.reportPreviewData?.reportName === '' ?state.reportPreviewData?.infoReport[0]?.ReportName :state.reportPreviewData?.reportName
      
      DownloadExcel(nameFile, sheetName, columns[0], valuesRep);
    }
  }

  
const handleViewSquare = () => {
  const newViewSquare = !viewSquare; // Invierte el valor actual
  const newSelViewSquare = newViewSquare ? "#093C5D" : "#707070";
  setViewSquare(newViewSquare);
  setSelViewSquare(newSelViewSquare);  
  dispatch({
    type: Types.LOAD_DATA_REPORT,
    payload: {      
      ...state.reportPreviewData,
      viewSquare: newViewSquare,
      selViewSquare: newSelViewSquare,
    },
  });
};


const handleReload = async () => {
  // Limpiar estados antes de cargar
  dispatch({
    type: Types.LOAD_DATA_REPORT,
    payload: {
      ...state.reportPreviewData,
      reload: false,
      deleteColumns: [],
      inpuntValues: [],
      previewLoading: true,
    },
  });

  try {
    let reportJson: any[] = [];
    let columns: string[] = [];
    let rows: string[] = [];
    let filterValues = {};

    if (!id.includes("custom-")) {
      const { data } = await getReportSingle({
        variables: { getDatareportsId: id },
      });

      if (data?.GET_DATAREPORTS?.length > 0) {
        reportJson = renamePropertiesSpanish(JSON.parse(data.GET_DATAREPORTS));
        filterValues = JSON.parse(infoReport[0]?.filtros || "[]") || [];
        columns = Object.keys(reportJson[0]);
        rows = []; // Si no tienes filas específicas
      }
    } else {
      const { data } = await getCustomReportSingle({
        variables: { getDatareportsId: id.replace("custom-", "") },
      });

      if (data?.GET_CUSTOMDATAREPORT?.length > 0) {
        const reportData = JSON.parse(data.GET_CUSTOMDATAREPORT);
        reportJson = reportData?.query || [];
        filterValues = JSON.parse(infoReport[0]?.filtros || "[]") || [];
        columns = reportData?.columnas || [];
        rows = reportData?.filas || [];
      }
    }

    // Pivotes únicos (si los necesitas)
    const pivots = [...columns, ...rows].filter((v, i, self) => self.indexOf(v) === i);

    // Dispatch con toda la info actualizada
    dispatch({
      type: Types.LOAD_DATA_REPORT,
      payload: {
        ...state.reportPreviewData,
        report: reportJson,
        reportFilter: reportJson,
        columnas: columns,
        filas: rows,
        inpuntBdValues: filterValues,
        camposPivotes: pivots,
        inpuntValues: [],
        reload: true,
        previewLoading: false,
      },
    });
  } catch (error) {
    console.error("Error en handleReload:", error);
    dispatch({
      type: Types.LOAD_DATA_REPORT,
      payload: {
        ...state.reportPreviewData,
        previewLoading: false,
      },
    });
  }
};

const createReport = async () => {
    if(state.previewData.name && state.previewData.rows.length > 0 && state.previewData.columns.length > 0){
      await createCustomReport({
        variables: {
          input: {
            name: state.previewData?.name,
            description:state.previewData?.description,
            ...(state.previewData?.rows?.length > 0 && { rows: state.previewData?.rows }),
            ...(state.previewData?.columns?.length > 0 && { columns: state.previewData?.columns }),
            ...(state.previewData?.filterJson && {filterJson: state.previewData?.filterJson})
          }
        }
      })
      await SuccessfulAlert({ text: "Se ha creado el informe correctamente" });
      goBack()
    }else{
      let faltanes: any[] =[]
      Object.keys(state.previewData).map((val :any) => {
        if(!state.previewData[val] || state.previewData[val].length === 0){
          let spanish = ''
          switch(val){
            case 'name':
              spanish = " el nombre del informe"
              break;
            case 'rows':
              spanish = ' las filas'
              break
            case 'columns':
              spanish = ' las columnas'
              break
          }
          faltanes.push(spanish)
        }
      })

      let text2 = faltanes.join(',')
      
      await AttentionAlert2({text: `No es posible crear este informe, faltan datos requeridos (${text2}) `})
    }
  }

const getPreviewInfo = async () => {
  const previewData = state.previewData;
  if (!previewData) return;
  setPreviewLoading(true);
  try {
    const { data } = await getCustomReportPreview({
      variables: { input: previewData },
    });
    // Parse seguro del reporte
    let reportJson: any[] = [];
    try {
      reportJson = data?.GET_CUSTOM_REPORT_PREVIEW
        ? JSON.parse(data.GET_CUSTOM_REPORT_PREVIEW)
        : [];
    } catch {
      reportJson = [];
    }  
    // Parse seguro de filtros
    let filterValues = {};
    try {
      filterValues = previewData.filterJson ? JSON.parse(previewData.filterJson) : {};
    } catch {
      filterValues = {};
    }

    // Columnas y filas
    const columns = previewData.columns?.map((c: any) => c.columnName) || [];
    const rows = previewData.rows?.map((r: any) => r.columnName) || [];

    // Pivotes únicos
    const pivots = [...(previewData.columns || []), ...(previewData.rows || [])]
      .flatMap(({ columnName, isPivot }) => (isPivot ? [columnName] : []))
      .filter((v, i, self) => self.indexOf(v) === i);

     const obj: Record<string, string> = Object.fromEntries(
            columns.map((key: string): [string, string] => [key, ""])
          );
     const columnsObj = Object.keys(obj);

    // Dispatch con todos los estados que tenías antes
    dispatch({
      type: Types.LOAD_DATA_REPORT,
      payload: {
        infoReport,
        camposBd,
        camposBdArray,
        setCamposBdArray,
        inpuntBdValues: filterValues,
        setInpuntBdValues,
        report: reportJson,
        setReport,
        reportFilter: reportJson,
        setReportFilter,
        reload,
        setReload,
        viewFilter,
        viewSquare,
        setDeleteColumns,
        deleteColumns,      
        columnas: columns,
        setColumnas,
        inpuntValues:[],
        setInpuntValues,
        filas: rows,
        setFilas,
        camposPivotes: pivots,
        previewLoading: false,
      },
    });
    setPreviewLoading(false);
  } catch (error) {
    console.error("Error en getPreviewInfo:", error);    
    dispatch({
      type: Types.LOAD_DATA_REPORT,
      payload: {
        previewLoading: false,
      },
    });
    setPreviewLoading(false);
  }
};

useEffect(() => {
  if (state.previewData) {
    getPreviewInfo();
  } else if (
    reportsInfo?.GET_ALL_DATAREPORTS ||
    customReportsInfo?.GET_ALL_CUSTOMREPORTS ||
    reportIndividual?.GET_DATAREPORTS ||
    customReportIndividual?.GET_CUSTOMDATAREPORT
  ) {
    getReportInfo();
  }
}, [
  state.previewData,
  reportsInfo,
  customReportsInfo,
  reportIndividual,
  customReportIndividual,
]);

const getReportInfo = async () => {
 
  try {
    setPreviewLoading(true);    
    if (
      !reportsInfo?.GET_ALL_DATAREPORTS &&
      !customReportsInfo?.GET_ALL_CUSTOMREPORTS &&
      !reportIndividual?.GET_DATAREPORTS &&
      !customReportIndividual?.GET_CUSTOMDATAREPORT
    ) {
      console.warn("⏳ Esperando datos del servidor...");
      setPreviewLoading(false);
      return;
    }

    let tempInfoReport: any[] = [];
    let tempCamposBd: string | null = null;
    let tempCamposBdArray: any[] = [];
    let tempInpuntBdValues: Record<string, any> = {};
    let tempReport: any[] = [];
    let tempReportFilter: any[] = [];
    let tempColumnas: string[] = [];
    let tempFilas: string[] = [];
    let tempCamposPivotes: string[] = [];
    let tempReportType = "";
    let tempReportName = "";
    
    if (reportsInfo?.GET_ALL_DATAREPORTS && !id.includes("custom-")) {
      tempInfoReport = filterMyReports(reportsInfo.GET_ALL_DATAREPORTS);
      if (tempInfoReport.length > 0) {
        const info = tempInfoReport[0];
        tempReportType = info.ReportType;
        tempReportName = info.ReportName;

        if (info.campos) tempCamposBdArray = renamePivots(info.campos.split(","));
        tempCamposBd = info.campos || null;
        
        if (info.filtros) {
          try {
            tempInpuntBdValues = JSON.parse(info.filtros);
          } catch {
            tempInpuntBdValues = {};
          }
        }
      }
    }

    if (customReportsInfo?.GET_ALL_CUSTOMREPORTS && id.includes("custom-")) {
      tempInfoReport = filterMyReports(
        customReportsInfo.GET_ALL_CUSTOMREPORTS.map((customReport: any) => ({
          ReportDate: customReport.dateAdd,
          ReportDescription: "",
          ReportName: customReport.name,
          ReportSQL: `${customReport.sqlQueryRows};${customReport.sqlQueryColumns}`,
          ReportType: "Personalizado",
          id: `custom-${customReport.id}`,
          userAdd: "custom_report",
          campos: null,
          filtros: customReport.filtros,
        }))
      );
    }

    if (reportIndividual?.GET_DATAREPORTS && !id.includes("custom-")) {
      try {
        const objReport = renamePropertiesSpanish(JSON.parse(reportIndividual.GET_DATAREPORTS));
        tempReport = objReport;
        tempReportFilter = objReport;
        tempColumnas = Object.keys(objReport[0] || {});
      } catch (e) {
        console.error("Error parseando reportIndividual:", e);
      }
    }

    if (customReportIndividual?.GET_CUSTOMDATAREPORT && id.includes("custom-")) {
      try {
        const objReport = JSON.parse(customReportIndividual.GET_CUSTOMDATAREPORT);
        tempReport = objReport?.query || [];
        tempReportFilter = objReport?.query || [];
        tempFilas = objReport?.filas || [];
        tempColumnas = objReport?.columnas || [];
        tempCamposPivotes = renamePivots(
          objReport?.pivotes?.map((el: any) => el.dataColumn) || []
        );
      } catch (e) {
        console.error("Error parseando customReportIndividual:", e);
      }
    }

     const objColumns: Record<string, string> = Object.fromEntries(
            tempColumnas.map((key: string): [string, string] => [key, ""])
          );

    dispatch({
      type: Types.LOAD_DATA_REPORT,
      payload: {
        infoReport: tempInfoReport,
        camposBd: tempCamposBd,
        camposBdArray: tempCamposBdArray,
        setCamposBdArray,
        inpuntBdValues: tempInpuntBdValues,
        setInpuntBdValues,
        report: tempReport,
        setReport,
        reportFilter: tempReportFilter,
        setReportFilter,
        reload,
        setReload,
        viewFilter,
        viewSquare,
        setDeleteColumns,
        deleteColumns,   
        columnas: tempColumnas,
        setColumnas,
        nameColumns:objColumns,
        setNameColumnas,
        inpuntValues:[],
        setInpuntValues,
        filas: tempFilas,
        setFilas,
        camposPivotes: tempCamposPivotes,
        reportType: tempReportType,
        reportName: tempReportName,
        previewLoading: false,
      },
    });

    setPreviewLoading(false);
  } catch (error) {
    console.error("❌ Error en getReportInfo:", error);
    dispatch({ type: Types.LOAD_DATA_REPORT, payload: { previewLoading: false } });
    setPreviewLoading(false);
  }
};


  return (
    <div>
      <Box mt={3} ml={5} className="TitleReportSingle" mb={2} p={5} pb={3} pt={0}>
        <Grid
          container
          justify="flex-start"
          alignItems="center"
        >
          <Grid className="btnsInformes">
            <Grid className="btnsInformesFiltros" >
              {state.previewData && <>
                {`Personalizado / Previsualización / ${state.previewData?.name}`}
              </>}
               {state.previewData === null && (
                <>
                   {`${state.reportPreviewData?.reportType === ''? 
                       state.reportPreviewData?.infoReport[0]?.ReportType : state.reportPreviewData?.reportType }
                     / ${state.reportPreviewData?.reportName === '' ?state.reportPreviewData?.infoReport[0]?.ReportName :state.reportPreviewData?.reportName}`} 
                </>
              )}
            </Grid>
            {
              state.previewData === null && (
                <Grid className="actionsReports" >
                  <TuneIcon
                    className="pointR"
                    sx={{ color: selViewFilter }}
                    onClick={() => handleViewFilter()}
                  />
                  <img
                    className='downExcelReport'
                    src={DownExcel}
                    onClick={() => handleDownExcel()
                    }
                    alt="descargar excel" />
                  <CachedIcon
                    className="pointR"
                    sx={{ color: '#093C5D' }}
                    onClick={() => handleReload()}
                  />
                  <div className="r-line"></div>
                  <GridOnIcon
                    className="pointR"
                    sx={{ color: selViewSquare }}
                    onClick={() => handleViewSquare()}
                  />
                  <div className="r-line"></div>
                  {/* 
                  <SendIcon
                    className="senR"
                    sx={{ color: '#093C5D' }}
                  />
                  */}
                </Grid>
              )
            }
            {
              state.previewData && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '20px',
                }}>
                  <button style={{
                    width: '168px',
                    height: '38px',
                    borderRadius: '6px',
                    background: 'white',
                    border: '1px solid #c7ccdc',
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: '14px',                    
                    lineHeight: '16px',
                    letterSpacing: '0px',
                    color: '#093c5d',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer'
                  }}
                    type="button" onClick={goBack}>Regresar</button>
                  <AddTable
                    func={createReport}
                    text="Crear informe"
                    img="report-icon.svg"
                    type="button"
                  />
                </div>
              )
            }
          </Grid>
        </Grid>
      </Box>
      <div className="contenedorReportSingle">
        <ReportIndividual
          loading={!id.includes('custom-') && !id.includes('preview') ? loading : 
            id.includes('custom-') && !id.includes('preview') ? loadingCustomReport :
            previewLoading
          }
     
        />
      </div>
      <button style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    height: '24px'
                  }}
                    onClick={goBack}
                  >
                    <img src="/assets/svg/back-button.svg" alt="Regresar" />
                    <span style={{
                      fontFamily: 'Roboto',
                      fontSize: '16px',                      
                      lineHeight: '19px',
                      color: '#222222',
                      marginLeft: '20px'
                    }}>Regresar</span>
                  </button>  
    </div>
  )
}

export default ReportInfo
